/**
 * TOTP enrollment + status surface — ROADMAP #18.
 *
 * Used by `/setup-2fa` (enrollment) + the Profile page TOTP section
 * (Disable + status badge). The `/login` two-step path lives in
 * `api/auth.ts` next to the regular login flow so callers don't have
 * to import from two places to drive a sign-in.
 */
import { apiClient } from './client';

export interface TOTPSetupResponse {
  base32_secret: string;
  otpauth_uri: string;
}

export interface TOTPEnableResponse {
  backup_codes: string[];
}

export interface TOTPStatusResponse {
  enabled: boolean;
  backup_codes_remaining: number;
}

export async function setupTotp(): Promise<TOTPSetupResponse> {
  const { data } = await apiClient.get<TOTPSetupResponse>(
    '/api/v1/auth/totp/setup',
  );
  return data;
}

export async function enableTotp(
  base32Secret: string,
  code: string,
): Promise<TOTPEnableResponse> {
  const { data } = await apiClient.post<TOTPEnableResponse>(
    '/api/v1/auth/totp/enable',
    { base32_secret: base32Secret, code },
  );
  return data;
}

export async function disableTotp(password: string): Promise<void> {
  await apiClient.post('/api/v1/auth/totp/disable', { password });
}

export async function getTotpStatus(): Promise<TOTPStatusResponse> {
  const { data } = await apiClient.get<TOTPStatusResponse>(
    '/api/v1/auth/totp/status',
  );
  return data;
}
